import React, { useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
// import "./Stepper.css"; // Custom CSS for styling

const Stepper = ({current_state}) => {
  const [currentStep, setCurrentStep] = useState(current_state);

  const steps = [
    { id: 1, label: "Order Received", component: "" },
    { id: 2, label: "Shipping", component: "" },
    { id: 3, label: "Payment", component: "" },
    { id: 4, label: "Finished", component: "" },
  ];

  const nextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className="stepper-container mt-5">
      {/* Stepper Navigation */}
      <Row className="justify-content-center mb-4">
        {steps.map((step, index) => (
          <Col
            key={step.id}
            className={`step ${
              currentStep === step.id ? "active-step" : ""
            } ${currentStep > step.id ? "completed-step" : ""}`}
            xs={3}
          >
            <div className="circle">{step.id}</div>
            <p className="step-label">{step.label}</p>
            {index < steps.length - 1 && (
              <div className="step-line"></div>
            )}
          </Col>
        ))}
      </Row>

      {/* Step Content */}
      {/* <Card>
        <Card.Body>
          <p>{steps[currentStep - 1].content}</p>
        </Card.Body>
      </Card> */}

      {/* Navigation Buttons */}
      {/* <div className="d-flex justify-content-between mt-3">
        <Button
          variant="secondary"
          onClick={prevStep}
          disabled={currentStep === 1}
        >
          Previous
        </Button>
        <Button
          variant="primary"
          onClick={nextStep}
          disabled={currentStep === steps.length}
        >
          Next
        </Button>
      </div> */}
    </div>
  );
};

export default Stepper;
